import { createFileRoute, Link } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MarketingLayout, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/customers")({
  head: () =>
    buildSeo({
      path: "/customers",
      title: "Who uses Reality Twin — customers & use cases",
      description:
        "Reality Twin helps SMBs, agencies and growing teams answer customers, qualify leads and surface opportunities with an AI Twin.",
    }),
  component: CustomersPage,
});

function CustomersPage() {
  const { t } = useTranslation();
  const perks = t("routes.customers.perks", { returnObjects: true }) as {
    title: string;
    desc: string;
  }[];
  return (
    <MarketingLayout>
      <I18nPageHero tKey="pages.customers" />

      <section className="border-b border-border py-16">
        <div className="mx-auto max-w-3xl px-6 space-y-5 text-[16px] leading-[1.7] text-muted-foreground">
          <p>{t("routes.customers.p1")}</p>
          <p>
            {t("routes.customers.p2Pre")}
            <strong className="text-foreground">{t("routes.customers.p2Strong")}</strong>
            {t("routes.customers.p2Post")}
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-border hairline rounded-xl overflow-hidden">
            {perks.map((p) => (
              <div key={p.title} className="bg-card p-7">
                <h3 className="font-serif text-[22px] leading-tight">{p.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-muted-foreground">{p.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 rounded-full bg-foreground px-5 py-3 text-[14px] font-medium text-background hover:opacity-90 transition"
            >
              {t("routes.customers.cta")} <ArrowRight className="h-3.5 w-3.5" />
            </Link>
            <p className="mt-3 text-[12.5px] text-muted-foreground">
              {t("routes.customers.ctaNote")}
            </p>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
